import { createSlice } from "@reduxjs/toolkit";
import { HYDRATE } from "next-redux-wrapper";

import * as actions from "./Actions";

const initialState = {
  isLoading: false,
  error: "",
  success: false,
  data: {},
};

const healthProgramV1Slice = createSlice({
  name: "healthProgramV1",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      //HYDRATE
      .addCase(HYDRATE, (state, { payload }) => ({
        ...state,
        ...payload.healthProgramV1,
      }))
      // GET HEALTH LANDING PAGE
      .addCase(actions.getHealthLandingPageV1.pending, (state) => ({
        ...state,
        isLoading: true,
        success: false,
        error: "",
      }))
      .addCase(
        actions.getHealthLandingPageV1.fulfilled,
        (state, { payload }) => {
          return {
            ...state,
            isLoading: false,
            success: true,
            data: payload?.data,
          };
        }
      )
      .addCase(
        actions.getHealthLandingPageV1.rejected,
        (state, { payload }) => ({
          ...state,
          isLoading: false,
          error: payload || "",
        })
      );
  },
});

export { getHealthLandingPageV1 } from "./Actions";

export default healthProgramV1Slice.reducer;
